import { YOO_FINDS_CDN } from "@/common";

const ROOT = `${YOO_FINDS_CDN}/common/totural/v2/en`;

export const TUTORIAL_IMAGES = [
  `${ROOT}/1.png`,
  `${ROOT}/2.png`,
  `${ROOT}/3.png`,
];
